import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./BusSearchDown.css";
import { Center } from "@chakra-ui/react";

// import offersData from "../data/offersData";


const offersData = [
  {
    id: 1,
    category: "Bus",
    title: "Save up to Rs 300 on bus tickets",
    valid_till: "31 Jan",
    code: "BUS300",
    theme: "pink",
  },
  {
    id: 2,
    category: "Bus",
    title: "Save up to Rs 500 with Axis Bank Credit Cards",
    valid_till: "31 Jan",
    code: "AXIS500",
    theme: "rose",
  },
  {
    id: 3,
    category: "Bus",
    title: "Save up to Rs 500 on IDFC FIRST Bank Credit Cards",
    valid_till: "31 Jan",
    code: "IDFC500",
    theme: "light",
  },
  {
    id: 4,
    category: "Bus",
    title: "Save up to Rs 200 with AU Bank Credit Cards",
    valid_till: "31 Jan",
    code: "AUBUS200",
    theme: "purple",
  },
  {
    id: 5,
    category: "Train",
    title: "Save up to Rs 100 on train tickets",
    valid_till: "31 Jan",
    code: "TRAIN100",
    theme: "pink",
  },
];








const Offers = () => {
  const [activeTab, setActiveTab] = useState("All");

  const filteredOffers =
    activeTab === "All"
      ? offersData
      : offersData.filter((o) => o.category === activeTab);

  return (
    <div className="offers-wrapper">
      {/* Header */}
      {/* <div className="offers-header">
        <h2>Offers for you</h2>
        <span className="view-more">View more</span>
      </div> */}

      {/* Tabs */}
      {/* <div className="offers-tabs">
        {["All", "Bus", "Train"].map((tab) => (
          <button
            key={tab}
            className={`tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div> */}

      {/* Swiper */}
      {/* <Swiper
        modules={[Navigation]}
        navigation
        spaceBetween={20}
        slidesPerView={4}
        breakpoints={{
          0: { slidesPerView: 1.1 },
          600: { slidesPerView: 2 },
          1024: { slidesPerView: 4 },
        }}
        className="offers-swiper"
      >
        {filteredOffers.map((offer) => (
          <SwiperSlide key={offer.id}>
            <div className={`offer-card ${offer.theme}`}>
              <span className="tag">{offer.category}</span>
              <h3>{offer.title}</h3>
              <p>Valid till {offer.valid_till}</p>
              <div className="coupon">{offer.code}</div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper> */}

      {/* What's New */}
      <h2 className="whats-new">What's coming soon</h2>

      <div className="new-cards" style={{ display: "flex", gap: "20px", flexWrap: "wrap", justifyContent: "center" }  }>
        <div className="new-card dark">
          <h3>Maximum savings on car insurance.</h3>
          <p>Cashless claims everywhere.</p>
          <button>Insure now</button>
        </div>

        <div className="new-card maroon">
          <h3>Free Cancellation</h3>
          <p>Get 100% refund on cancellation</p>
          <span>Know more →</span>
        </div>

        <div className="new-card white">
          <h3>Introducing Bus timetable</h3>
          <p>Get local bus timings between cities in your state</p>
        </div>

        <div className="new-card blue">
          <h3>FlexiTicket</h3>
          <p>Date Change & Cancellation benefits</p>
          <span>Know More →</span>
        </div>
      </div>
       <section className="rb-info">
      {/* Intro */}
      <div className="rb-intro">
        <h2>India’s Leading Online Bus Ticket Booking Platform</h2>
        <p>
          It is India’s leading bus ticket booking platform for over
          <strong> 2 years</strong> with <strong>56k+ </strong> satisfied users.
          Enjoy a seamless booking experience with the best prices and exclusive offers.
        </p>
      </div>

      {/* Stats */}
      <div className="rb-stats">  
        <div className="rb-stat">
          <h3>5200+</h3>
          <p>Bus Operators</p>
        </div>
        <div className="rb-stat">
          <h3>7,30,000+</h3>
          <p>Routes</p>
        </div>
        <div className="rb-stat">
          <h3>56k+</h3>
          <p>Happy Users</p>
        </div>
      </div>

      {/* Bus Booking */}
      <div className="rb-section">
        <h3>Why Choose it for Bus Booking?</h3>
        <div className="rb-grid">
          <div className="rb-card">🆓 Free Cancellation</div>
          <div className="rb-card">📅 Flexi Ticket</div>
          <div className="rb-card">🎁 Earn Rewards</div>
          <div className="rb-card">👩 Booking for Women</div>
          <div className="rb-card">⭐ Primo Services</div>
          <div className="rb-card">📞 24/7 Customer Support</div>
          <div className="rb-card">💸 Instant Refund</div>
          <div className="rb-card">🚌 Live Bus Tracking</div>
        </div>
      </div>

      {/* Train Booking */}
      {/* <div className="rb-section light">
        <h3>Why Choose redRail for Train Ticket Booking?</h3>
        <ul className="rb-list">
          <li>✅ Authorised IRCTC Partner</li>
          <li>🆓 Free Cancellation</li>
          <li>🔁 Alternate Trip with 3X Refund</li>
          <li>📞 24/7 Customer Support</li>
        </ul>
      </div> */}

      {/* Steps */}
      <div className="rb-section">
        <h3>How to Book Bus Tickets on Jayraj</h3>
        <ol className="rb-steps">
          <li>Visit Jayraj website or app</li>
          <li>Select Bus</li>
          <li>Choose travel date & journey details</li>
          <li>Select preferred bus</li>
          <li>Enter boarding & contact details</li>
          <li>Make payment</li>
          <li>Get instant confirmation</li>
        </ol>
      </div>

      {/* Offers */}
      <div className="rb-offer">
        <h3>Exclusive Offers on Jayraj 🎉</h3>
        <p>
          Get exciting discounts on bus ticket bookings. Apply coupon
          codes available on the website or app and enjoy festive and seasonal offers.
        </p>
      </div>
    </section>
    </div>
  );
};

export default Offers;
